import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, FileText, ListChecks, ShieldAlert, MessageCircle, ArrowRight, X, CheckCircle2 } from 'lucide-react';
const contents = [{
  icon: ShieldAlert,
  title: 'Mapa de Puntos de Riesgo (9)',
  desc: 'Tu ruta de prevención con señales tempranas y acción concreta.'
}, {
  icon: MessageCircle,
  title: 'Scripts Copiables',
  desc: "Para realtor, lender, title/escrow. Incluye el 'triángulo' para cuando se echan la bolita."
}, {
  icon: ListChecks,
  title: 'Checklists por Etapa',
  desc: '24h bajo contrato, 48h antes de vencer DD, antes de remover contingencias, al llegar CD, día de closing.'
}, {
  icon: FileText,
  title: 'Mini‑módulo HOA/Condo',
  desc: 'Red flags + cómo pedir docs temprano + cómo no firmar a ciegas.'
}, {
  icon: Check,
  title: 'Plantillas de Confirmación',
  desc: 'Formatos post-llamada para que nada quede en el aire.'
}];
const detailedContents = [{
  category: 'Mapa de Puntos de Riesgo — Los 9 Momentos',
  items: ['1. Cuando el EMD no se confirma — señales de que tu depósito no llegó o no fue registrado', '2. Cuando no existe timeline real — y nadie te da fechas concretas con responsables', '3. Cuando inspección/appraisal se atrasan vs deadline — y tu contingencia corre igual', '4. Cuando se "acuerda" algo sin addendum — acuerdos verbales que no existen legalmente', '5. Cuando remueves contingencias sin entender qué acabas de perder — el punto de no retorno', '6. Cuando el cash‑to‑close sube y nadie explica por línea — cambios silenciosos en tus números', '7. Cuando el CD trae errores y nadie lo "own" — y todos se echan la bolita', '8. Cuando HOA docs llegan tarde — el PDF gigante que te puede costar el depósito', '9. Cuando te ignoran y tú no escalas — cómo forzar respuestas sin quemar relaciones']
}, {
  category: 'Qué incluye cada punto de riesgo',
  items: ['Señales tempranas para detectar el problema antes de que explote', 'Acción concreta: qué haces hoy, paso a paso', 'Script copy/paste listo para enviar al responsable correcto', 'Indicadores de cuándo escalar y a quién']
}, {
  category: 'Scripts de Presión Limpia',
  items: ['Script para confirmar recepción del EMD con escrow', 'Script para pedir timeline real al lender', 'Script para escalar cuando inspección/appraisal se atrasan', 'Script para exigir correcciones en el Closing Disclosure', 'Script del "triángulo" cuando realtor, lender y title se echan la bolita', 'Script para pedir extensiones sin sonar desesperada', 'Plantilla de "confirmación post-llamada" para que todo quede por escrito']
}, {
  category: 'Checklists por Etapa',
  items: ['Checklist: Primeras 24 horas bajo contrato', 'Checklist: 48 horas antes de que venza tu Due Diligence', 'Checklist: Antes de remover contingencias', 'Checklist: Al recibir el Closing Disclosure', 'Checklist: Día de closing — verificación final']
}, {
  category: 'Mini-módulo HOA/Condo',
  items: ['Red flags en documentos HOA que debes detectar', 'Cómo pedir los docs temprano (antes de que sea tarde)', 'Qué buscar en el presupuesto y reservas del HOA', 'Cómo no firmar a ciegas el último día']
}, {
  category: 'Plantillas y Herramientas',
  items: ['Plantilla de confirmación post-llamada (copy/paste)', 'Formato para documentar acuerdos verbales', 'Guía rápida: cuándo necesitas un addendum', 'Referencia rápida de contingencias y sus deadlines']
}];
export function WhatsInsideSection() {
  const [showDetail, setShowDetail] = useState(false);
  return <>
      <section className="py-24 px-4 bg-[#0F1419] text-[#F5F0E8]" data-id="element-326">
        <div className="max-w-5xl mx-auto" data-id="element-327">
          <div className="text-center mb-16" data-id="element-328">
            <span className="text-[#D4A843] font-medium tracking-widest uppercase text-sm" data-id="element-329">
              Lo que recibes
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold mt-3 mb-6" data-id="element-330">
              Kit Anti‑Pérdidas: Protege Tu Depósito + Contingencias
            </h2>
            <p className="text-[#8B8578] max-w-2xl mx-auto" data-id="element-331">
              Formato: PDF mobile‑first + printable (scripts listos para
              copiar/pegar).
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-332">
            {contents.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className={`bg-[#1A1F2E] p-8 rounded-xl border border-[#D4A843]/10 hover:border-[#D4A843]/30 transition-all group ${index === 0 || index === 1 ? 'md:col-span-1' : ''}`} data-id="element-333">
                <div className="w-12 h-12 bg-[#0B0E13] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform border border-[#D4A843]/20" data-id="element-334">
                  <item.icon className="w-6 h-6 text-[#D4A843]" data-id="element-335" />
                </div>
                <h3 className="text-xl font-bold text-[#F5F0E8] mb-3" data-id="element-336">
                  {item.title}
                </h3>
                <p className="text-[#8B8578] leading-relaxed" data-id="element-337">{item.desc}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-338">
            <button onClick={() => setShowDetail(true)} className="inline-flex items-center px-8 py-4 bg-[#1A1F2E] border border-[#D4A843] text-[#D4A843] hover:bg-[#D4A843] hover:text-[#0B0E13] font-bold rounded-lg transition-all duration-300" data-id="element-339">
              <span data-id="element-340">Ver todo lo que incluye</span>
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-341" />
            </button>
          </div>
        </div>
      </section>

      {/* Detail Modal */}
      <AnimatePresence data-id="element-342">
        {showDetail && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={() => setShowDetail(false)} data-id="element-343" />
            <motion.div initial={{
          opacity: 0,
          y: 40,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 40,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="fixed inset-4 md:inset-auto md:top-[5%] md:left-1/2 md:-translate-x-1/2 md:w-full md:max-w-2xl md:max-h-[90vh] bg-[#0F1419] border border-[#D4A843]/20 rounded-2xl z-50 flex flex-col shadow-2xl" data-id="element-344">
              <div className="flex items-center justify-between p-6 border-b border-[#1A1F2E]" data-id="element-345">
                <div data-id="element-346">
                  <h2 className="text-xl font-serif font-bold text-[#F5F0E8]" data-id="element-347">
                    ¿Qué incluye el Kit Anti‑Pérdidas?
                  </h2>
                  <p className="text-sm text-[#8B8578] mt-1" data-id="element-348">
                    Protege tu Depósito + Contingencias
                  </p>
                </div>
                <button onClick={() => setShowDetail(false)} className="p-2 rounded-lg hover:bg-[#1A1F2E] transition-colors text-[#8B8578] hover:text-[#F5F0E8] shrink-0" data-id="element-349">
                  <X className="w-5 h-5" data-id="element-350" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto flex-1 space-y-8" data-id="element-351">
                {detailedContents.map((section, sIdx) => <div key={sIdx} data-id="element-352">
                    <h3 className="text-[#D4A843] font-bold text-sm uppercase tracking-widest mb-4" data-id="element-353">
                      {section.category}
                    </h3>
                    <ul className="space-y-3" data-id="element-354">
                      {section.items.map((item, iIdx) => <li key={iIdx} className="flex items-start" data-id="element-355">
                          <CheckCircle2 className="w-4 h-4 text-[#4A8B6E] mr-3 mt-0.5 shrink-0" data-id="element-356" />
                          <span className="text-sm text-[#F5F0E8]" data-id="element-357">{item}</span>
                        </li>)}
                    </ul>
                  </div>)}

                <div className="bg-[#1A1F2E] rounded-xl p-5 border border-[#D4A843]/20 text-center" data-id="element-358">
                  <p className="text-[#8B8578] text-sm mb-4" data-id="element-359">
                    Todo en formato{' '}
                    <span className="text-[#F5F0E8] font-bold" data-id="element-360">
                      PDF mobile-first + printable
                    </span>
                    . Scripts listos para copiar y pegar.
                  </p>
                  <a href="https://www.betterbysteps.com/cart/44195063332957:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-[#D4A843] hover:bg-[#E8BC5A] text-[#0B0E13] font-bold rounded-lg transition-all duration-300 no-underline" data-id="element-361">
                    <span data-id="element-362">Obtener el Kit — $6.36</span>
                    <ArrowRight className="ml-2 w-5 h-5" data-id="element-363" />
                  </a>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}